import { TimelineTheme } from '../../types';

export const TIMELINE_DEFAULT_THEME: TimelineTheme = {
    spacing: 8,
    trackSpacing: 4,
    trackPointSize: 16,
    trackPointColor: 'grey.tint.200',
    trackWidth: 2,
    contentSpacing: 20,
};
